import PatientSelectionView from '@pages/PatientSetting/views/PatientSelection/PatientSelectionView';
import { PatientSelectionProvider } from '@context/PatientSelection';

const PatientSelection = () => {
  return (
    <PatientSelectionProvider>
      <PatientSelectionView />
    </PatientSelectionProvider>
  );
};

export default PatientSelection;
